import {Injectable} from "@angular/core";
import {TranslocoLoader} from "@jsverse/transloco";

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    // private http = inject(HttpClient);

    getTranslation(lang: string) {
      return import(`../../public/i18n/${lang}.json`).then(res => res.default);
        // return this.http.get<Translation>(`i18n/${lang}.json`);
    }
}
